import React from 'react';
import {
    Tooltip,
    IconButton,
    Checkbox,
    Box,
    Typography,
    Chip,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import { FULL_PERMISSION } from '../../../constants/Constant';
import { EditOutlined } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
// import SendIcon from '@mui/icons-material/Send';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
// import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import TextSnippetOutlined from '@mui/icons-material/TextSnippetOutlined';
// import CircularProgressWithLabel from '../../../sharedcomponents/crcularProgressWithLabel';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    columnContent: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        [theme.breakpoints.only('xs')]: {
            flexBasis: '19%',
        },
    },
    wrapTextStyle: {
        display: '-webkit-box',
        boxOrient: 'vertical',
        lineClamp: 2,
        wordBreak: 'break-all',
        overflow: 'hidden',
    },
    wrapTextSmallSize: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '30ch',
        fontSize: 12,
    },
    wrapAll: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary',
    },
}));

const DataListRowItem = (props) => {
    const classes = useStyles();
    const { row, item, index } = props;

    return (
        <Box
            key={index}
            className={classes.columnContent}
            sx={
                row.label === 'Action'
                    ? {
                          flex: `${row.width}`,
                          justifyContent: 'flex-end',
                      }
                    : !row.type && row.alignCenter != undefined
                    ? {
                          flex: `${row.width}`,
                          justifyContent: 'center',
                      }
                    : row.alignLeft != undefined
                    ? {
                          flex: `${row.width}`,
                          justifyContent: 'left',
                      }
                    : {
                          flex: `${row.width}`,
                          justifyContent: 'left',
                      }
            }>
            {row.label === 'checkbox' ? (
                <Checkbox
                    inputProps={{
                        'aria-label': 'Participant',
                    }}
                    checked={item.selected ? item.selected : false}
                    onChange={(event) => props.onCheckSelect(event, item)}
                    // color="secondary"
                    value={row[row.key]}
                    disabled={
                        item.disableRow != undefined ? item.disableRow : false
                    }
                />
            ) : row.label === 'checkboxEmail' ? (
                <>
                    <Checkbox
                        inputProps={{
                            'aria-label': 'Participant',
                        }}
                        checked={
                            item.emailSelected ? item.emailSelected : false
                        }
                        onChange={(event) => props.onEmailSelect(event, item)}
                        // color="secondary"
                        value={row[row.key]}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }
                    />
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={400}>
                        Email
                    </Typography>
                </>
            ) : row.label === 'notes' ? (
                <>
                    <IconButton
                        color="primary"
                        onClick={(event) => props.handleViewNotes(item, event)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <TextSnippetOutlined
                            fontSize="small"
                            color={'primary'}
                        />
                    </IconButton>
                </>
            ) : row.label === 'Action' ? (
                !props.showUsersList &&
                row[row.key] === 'View Home Detail'
                 ? (
                    <Tooltip title="View Home Detail" aria-label="add">
                        <IconButton
                            color="primary"
                            onClick={() => props.handleViewHomeDetails(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <VisibilityOutlinedIcon 
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) :
                !props.showUsersList &&
                row[row.key] === 'Add Participants' &&
                props.modPermission &&
                props.modPermission == FULL_PERMISSION ? (
                    <Tooltip title="Add Participants" aria-label="add">
                        <IconButton
                            color="primary"
                            onClick={() => props.handleAddParticipants(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <GroupAddIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) : !props.showUsersList &&
                  row[row.key] === 'Participants' &&
                  props.modPermission &&
                  props.modPermission == FULL_PERMISSION ? (
                    <Tooltip title="View Participants" aria-label="view">
                        <IconButton
                            color="primary"
                            onClick={() => props.handleViewParticipants(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <Badge badgeContent={row.count} color="primary">
                                <PeopleAltIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                ) : row[row.key] == 'Archive' &&
                  props.modPermission &&
                  props.modPermission == FULL_PERMISSION ? (
                    <Tooltip title="Archive" aria-label="add">
                        <IconButton
                            color="primary"
                            onClick={() => props.handleAddParticipants(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <ArchiveOutlinedIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) : row[row.key] == 'notes' ? (
                    <Tooltip title="Notification" aria-label="add">
                        <IconButton color="primary">
                            {!row.isOpened ? (
                                <TextSnippetOutlined
                                    fontSize="small"
                                    color={'primary'}
                                />
                            ) : (
                                <ChatBubbleOutlineOutlinedIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            )}
                        </IconButton>
                    </Tooltip>
                ) : // : row[row.key] == 'Send Email' &&
                //     props.modPermission &&
                //     props.modPermission == FULL_PERMISSION ? (
                //     <Tooltip title="Send" aria-label="add">
                //         {(props.customLoaderForEmail && item.actualData.notificationID === props.customNotificationID) ?
                //             <CircularProgressWithLabel value={props.progressValue} />
                //             :
                //             <IconButton
                //                 color="primary"
                //                 onClick={() => props.sendEmailNotification(item)}
                //                 disabled={
                //                     item.disableRow != undefined
                //                         ? item.disableRow
                //                         : false
                //                 }>
                //                 <SendIcon
                //                     fontSize="small"
                //                     color={
                //                         item.disableRow != undefined
                //                             ? 'default'
                //                             : 'primary'
                //                     }
                //                 />
                //             </IconButton>
                //         }
                //     </Tooltip>
                // )
                row[row.key] == 'Edit' &&
                  props.modPermission &&
                  props.modPermission == FULL_PERMISSION ? (
                    <Tooltip title="Edit" aria-label="edit">
                        <IconButton
                            color="primary"
                            onClick={() => props.editRow(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <EditOutlined
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) : null
            ) : row.showChips != undefined ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection:
                            row.inColumn != undefined ? 'column' : 'row',
                        justifyContent:
                            row.alignCenter != undefined
                                ? row.type
                                    ? 'left'
                                    : 'center'
                                : 'left',
                        alignItems:
                            row.alignCenter != undefined ? 'center' : 'start',
                        flexWrap: 'wrap',
                    }}>
                    {row[row.key]
                        ? row[row.key].split(', ').map((chipItem) => {
                              return (
                                  chipItem !== '' && (
                                      <Chip
                                          key={chipItem}
                                          label={chipItem}
                                          sx={{
                                              mr: '4px',
                                              mb: '2px',
                                              '& .MuiChip-label': {
                                                  maxWidth: '30ch',
                                              },
                                          }}
                                      />
                                  )
                              );
                          })
                        : null}
                </Box>
            ) : row[row.key] && row[row.key].length >= 0 ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection:
                            row.inColumn != undefined ? 'column' : 'row',
                        justifyContent:
                            row.alignCenter != undefined
                                ? row.type
                                    ? 'left'
                                    : 'center'
                                : 'left',
                        alignItems:
                            row.alignCenter != undefined ? 'center' : 'start',
                    }}>
                    {row.showLabel == undefined ? (
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                    ) : null}

                    {row.isSent ? (
                        <Typography fontSize={11}>{row.status}</Typography>
                    ) : row.titleRedirect == true ? (
                        <>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}
                                sx={{ cursor: 'pointer' }}
                                onClick={(event) =>
                                    props.handleViewNotes(item, event)
                                }>
                                {row[row.key] ? (
                                    <span
                                        className={classes.wrapTextStyle}
                                        dangerouslySetInnerHTML={{
                                            __html: row[row.key],
                                        }}
                                    />
                                ) : (
                                    ''
                                )}
                            </Typography>
                        </>
                    ) : (
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {row[row.key] ? (
                                <span
                                    className={classes.wrapTextStyle}
                                    dangerouslySetInnerHTML={{
                                        __html: row[row.key],
                                    }}
                                />
                            ) : (
                                ''
                            )}
                        </Typography>
                    )}
                    {row.showDetails ? (
                        <Typography fontSize={11}>
                            Created on {row.createdDate}, Created by{' '}
                            {row.createdBy}
                        </Typography>
                    ) : null}
                </Box>
            ) : null}
        </Box>
    );
};
export default DataListRowItem;
